import { getRefElement } from '../../utils';
export var globalListenerEventMap = new Map();
/**
 * create globalListener handler for share one listener event
 *
 * @example
 * ```ts
 * const globalListener = createGlobalListener('focus', () => { console.log('focus') });
 * const globalListener2 = createGlobalListener('focus', () => { console.log('focus') });
 * globalListener.listen();
 * globalListener2.listen();
 *
 * => // that will only create an event listener on window, but every callback will get emit value when event triggered
 * ```
 */
export var createGlobalListener = function (key, listener, options, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.customKey, customKey = _c === void 0 ? key : _c, _d = _b.target, targetProp = _d === void 0 ? window : _d;
    var listening = false;
    var getMapValue = function () { return globalListenerEventMap.get(customKey); };
    var addListener = function () {
        if (listening)
            return;
        var savedEvent = getMapValue();
        if (!(savedEvent === null || savedEvent === void 0 ? void 0 : savedEvent.exec)) {
            var exec = function (e) {
                var event = getMapValue();
                event === null || event === void 0 ? void 0 : event.listeners.forEach(function (c) { return c(e); });
            };
            globalListenerEventMap.set(customKey, {
                exec: exec,
                listeners: new Set([listener]),
            });
            var target = getRefElement(targetProp);
            target === null || target === void 0 ? void 0 : target.addEventListener(key, exec, options);
        }
        else {
            savedEvent.listeners.add(listener);
        }
        listening = true;
    };
    var removeListener = function () {
        if (!listening)
            return;
        listening = false;
        var _savedEvent = getMapValue();
        if (!_savedEvent)
            return;
        var listeners = _savedEvent.listeners;
        listeners.delete(listener);
        if (listeners.size === 0) {
            var target = getRefElement(targetProp);
            target === null || target === void 0 ? void 0 : target.removeEventListener(key, _savedEvent.exec, options);
            globalListenerEventMap.delete(customKey);
        }
    };
    return {
        listen: function () { return addListener(); },
        /**
         * remove listener
         */
        remove: function () { return removeListener(); },
        /**
         * current listener state
         */
        get state() {
            return {
                /**
                 * current listener state count
                 */
                get count() {
                    var _a;
                    return ((_a = getMapValue()) === null || _a === void 0 ? void 0 : _a.listeners.size) || 0;
                },
                /**
                 * is that be listening
                 */
                listening: listening,
            };
        },
    };
};
